import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=55799753&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&id=55799753&prod&scope=true&lang=css&"
import style1 from "./contact.vue?vue&type=style&index=1&id=55799753&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports